import { TiCampaignsView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';

/**
 * Treatment Intelligence — Campaigns tab (amendment 27 §4). The recall-list shape
 * with TC columns; every control goes somewhere.
 */
export function TiCampaignsPage() {
  const navigate = useNavigate();
  return (
    <TiCampaignsView
      onSelectTab={(tab) => {
        if (tab === 'opportunity') void navigate('/treatment-intelligence');
      }}
      onOpenSettings={() => { void navigate('/settings/ai/treatment-coordinator'); }}
      onNewCampaign={() => { void navigate('/treatment-intelligence/campaigns/new'); }}
      onReport={(id) => { void navigate(`/treatment-intelligence/campaigns/${id}/report`); }}
      onEdit={(id) => { void navigate(`/treatment-intelligence/campaigns/${id}/edit`); }}
      onContinue={(id) => { void navigate(`/treatment-intelligence/campaigns/${id}/edit`); }}
      onSeeUncovered={() => { void navigate('/treatment-intelligence'); }}
      onOpenCalls={() => { void navigate('/calls?type=treatment'); }}
    />
  );
}
